import { SwitchProps } from '@mui/material'
import { memo } from 'react'
import { StyledSwitch } from './switchV2.styles'

export type SwitchV2Props = SwitchProps

const SwitchV2 = ({ ...props }) => {
  return (
    <>
      <StyledSwitch {...props} />
    </>
  )
}

export default memo(SwitchV2)
